import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Modal, Paper, SelectChangeEvent, Typography } from '@mui/material'

import { FormSelect } from 'src/components/form-select'
import { ISortSelectOption } from 'src/components/filter/types/filter.types'

import { EAccountRoles } from 'src/types'
import { useStyles } from '../styles'
import { useAccountChangeUserRole } from 'src/hooks'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IInviteModalProps {
  open: boolean
  handleClose: () => void
  email: string
  id: string
}

const accountRolesSelect: ISortSelectOption[] = Object.entries(EAccountRoles).map(
  ([label, value]) => ({ label, value }),
)

const ChangeRoleModal = ({ handleClose, open, email, id }: IInviteModalProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const { mutate: changeRole } = useAccountChangeUserRole()
  const [role, setRole] = useState(EAccountRoles.admin)

  const handleButtonClick = () => {
    changeRole({ roles: [role], id })
    handleClose()
  }

  const handleSelectChange = (e: SelectChangeEvent) => {
    setRole(e.target.value as EAccountRoles)
  }

  return (
    <Modal
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      open={open}
      onClose={handleClose}
    >
      <Paper className={classes.changeUserRoleModalWrapper}>
        <Typography className={classes.inviteModalTitle} component="h2">
          <HelperWrapper t="account-users-change-role-title" />
        </Typography>
        <Typography sx={{ fontSize: '16px', mb: '25px' }}>{email}</Typography>
        <div className={classes.formInputsWrapper}>
          <FormSelect
            handleChange={handleSelectChange}
            items={accountRolesSelect}
            selectName={t('account-users-change-role-roles-select.v')}
            value={role}
            noClear
          />
        </div>
        <Box sx={{ mt: '25px' }}>
          <Button type="button" variant="contained" onClick={handleButtonClick}>
            <HelperWrapper t="account-users-change-role-submit" />
          </Button>
        </Box>
      </Paper>
    </Modal>
  )
}

export { ChangeRoleModal }
